const TransactionChannelType = Object.freeze({
  NATURAL_ACCOUNT: "NATURAL_ACCOUNT",
  BANK: "BANK",
  PLATFORM: "PLATFORM",
  GENERAL_LEDGER: "GENERAL_LEDGER",
  UNKNOWN: "UNKNOWN",
});

export default TransactionChannelType;
